// dependencies imports ⇒
import React from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
//scss or assets import ==>
import './doctorSlugBooking.scss'
//project file import ==>
import { siteURL } from "../../../Util/API Calls/APIList";
import beforeLoginApiCall from "../../../Util/API Calls/beforeLogin"
import { PATIENT_LOGIN_DOCTOR_SLUG } from "../PatientSignInAPIHandler/apiConstant";
import { DOCTOR_SLUG_BOOKING_CONTAINT } from "../constant";

const DoctorSlugBooking = () => {
    //const ==>
    const validationSchema = yup.object().shape({
        slug_url: yup.string().required("Slug url is required!"),
    });

    const {
        register,
        handleSubmit,
        errors,
        setError,
        setValue,
        getValues,
    } = useForm({
        defaultValues: {
            slug_url: "",
        },
        resolver: yupResolver(validationSchema),
    });

    //<== 

    //Api calls==>
    const onSlugSubmit = async (payload) => {
        const doctorSlug = payload.slug_url.substring(
            payload.slug_url.lastIndexOf("/") + 1
        );
        const { data } = await beforeLoginApiCall.post(
            PATIENT_LOGIN_DOCTOR_SLUG,
            {
                doctor_url_short_code: doctorSlug,
            }
        );
        if (data.statusCode == 200) {
            window.open(`${window.location.origin}/doctor/${doctorSlug}`, "_self");
        } else {
            setError("slug_url", {
                types: "invalid",
                message: "Please enter a valid URL",
            });
        }
    };
    //<==

    //create UI ==>
    const createDoctorSlugLoginUI = () => {
        return (
            <div>
                <div className="text-and-button-container">
                    <input
                        type="text"
                        name="slug_url"
                        placeholder={`${siteURL}doctor/`}
                        className=" text-container"
                        ref={register}
                        {...register("slug_url", { required: true })}
                        onClick={() => {
                            if (getValues("slug_url") == "") {
                                setValue("slug_url", `${siteURL}doctor/`);
                            }
                        }}
                    />
                    <div className="button-container">
                        <button onClick={handleSubmit(onSlugSubmit)}>Book Now</button>
                    </div>
                </div>
                <div style={{marginBottom: errors?.slug_url?.message ? "10px" : "0px"}} className="psic-text">
                    {errors?.slug_url?.message}
                </div>
            </div>
        )
    }

    const createDoctorSlugBooingMobileUI = () => {
        return (
            <div>
                <div className="psic-slug-container-background-view">
                    <div className="psic-slug-container-text-mobile-view">
                        {DOCTOR_SLUG_BOOKING_CONTAINT.BOOKINGTEXT}
                    </div>
                    <div className="psic-slug-mobile-text" >
                        {DOCTOR_SLUG_BOOKING_CONTAINT.CONTAINT}
                    </div>
                </div>
                {createDoctorSlugLoginUI()}
            </div>
        )
    }

    const createDoctorSlugBookingUI = () => {
        return (
            <div>
                <div className="login-container">
                    <div className="psic-slug-container-text">
                        {DOCTOR_SLUG_BOOKING_CONTAINT.BOOKINGTEXT}
                    </div>
                    <div className="psic-slug-container-text1">
                        {DOCTOR_SLUG_BOOKING_CONTAINT.CONTAINT}
                    </div>
                    {createDoctorSlugLoginUI()}
                </div>
            </div>
        )
    }
    //<==
    return (
        <div className="doctor-slug-booking">
            {window.innerWidth > 768 && createDoctorSlugBookingUI()}
            {window.innerWidth < 768 && createDoctorSlugBooingMobileUI()}
        </div>
    )
}


export default DoctorSlugBooking;